import React from "react";
import { useSignInVM } from "./SignInViewModel";
import SignInView from "./SignInView";

const SignIn: React.FC = () => {
  const vm = useSignInVM();

  return <SignInView state={vm.state} actions={vm.actions} />;
};

export default SignIn;